var _rect, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarGlassIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 45,
    height: 45,
    rx: 5,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_406_170)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 5,
    transform: "matrix(-1 0 0 1 45 6)",
    fill: "#E2DFFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    y: 0.25,
    width: 44.5,
    height: 44.5,
    rx: 4.75,
    transform: "matrix(-1 0 0 1 44.5 6)",
    stroke: "url(#paint0_linear_406_170)",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5308 18.5015C20.4963 17.6101 20.0372 17.7857 21.5134 17.7857C25.2337 17.7857 28.9539 17.7857 32.6742 17.7857C32.5594 17.9841 30.8586 19.4768 30.4314 19.8073C30.3012 19.908 30.2024 19.958 30.0822 20.059C29.6283 20.4403 29.2259 20.8121 28.7795 21.2038C28.552 21.4035 28.371 21.5622 28.1435 21.7619C27.9906 21.896 27.694 22.25 27.4279 22.25L15.3898 22.2487L19.5308 18.5015ZM13.373 24.0357H26.6011V35.6429H22.5945C22.2095 35.6429 22.1487 35.8103 21.927 36.0057C21.5667 36.3233 20.5099 37.1923 20.353 37.427C22.4114 37.4431 24.4786 37.4301 26.5379 37.4294C27.6888 37.4291 28.0545 37.0775 28.6196 36.577L33.1885 32.5503C33.7117 32.0891 34.1874 31.6683 34.7116 31.2081C35.1739 30.8021 35.7591 30.3879 35.7591 29.4487V17.0045C35.7591 16.3609 35.3481 16 34.6144 16H20.4322C19.6397 16 19.204 16.2063 18.8219 16.5962C18.1608 17.2708 14.14 20.7113 13.1341 21.5939C12.759 21.923 12.3817 22.2946 11.9824 22.5918C11.5542 22.9106 11.3379 23.3354 11.3379 23.9799L11.3501 33.4599C11.7027 33.2005 12.0821 32.8282 12.4274 32.5252C12.797 32.2008 13.373 31.8121 13.373 31.5134V24.0357Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7744 36.5246C11.311 35.9713 15.2171 32.6168 16.196 31.7578C16.403 31.5762 16.6964 31.1784 17.0621 31.1784C18.4647 31.1782 21.9248 31.1268 23.0954 31.1894C22.6305 31.6687 19.2351 34.5862 18.4369 35.2866C18.0406 35.6343 17.1645 36.5355 16.8077 36.5356C15.2471 36.5359 12.1582 36.5875 10.7744 36.5246ZM18.4612 37.9865C18.4612 37.7168 18.6136 37.6675 18.7712 37.5331L23.9231 33.0134C24.3385 32.6488 24.5665 32.5635 24.5665 32.2387V25.8213H23.5489V28.4999H22.5314V25.8213H21.5139V28.4999H20.4963V25.8213H19.4788V28.4999H18.4612V25.8213H17.4437V28.4999H16.4261V25.8213H15.4086V31.0668C15.4086 31.3087 14.7592 31.7753 14.5654 31.9453L10.0501 35.9074C9.88619 36.0512 9.76853 36.154 9.60492 36.298C9.46972 36.417 9.26072 36.5565 9.14332 36.6723C8.94537 36.8675 8.98433 37.8045 9.07063 38.1401C9.26083 38.4327 10.7496 38.3213 11.3383 38.3213V40.9999H12.3559V38.3213C13.6684 38.323 16.2733 38.3767 17.4437 38.2894V40.9999H18.4612V37.9865Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_406_170",
    x: -8,
    y: -2,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_406_170"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_406_170",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_170",
    x1: 75.5,
    y1: 21.5,
    x2: 40,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C60F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGlassIcon2);
export default __webpack_public_path__ + "static/media/star-glass-icon2.bf0c7da64b1806e2f9592c8f0704ef07.svg";
export { ForwardRef as ReactComponent };